module.exports = __webpack_public_path__ + "media/images/lms/schoology-5c453691dd12b5fe6bfee0f8e00cde91.png";